import { render, staticRenderFns } from "./UserSettingsPasswordChange.vue?vue&type=template&id=6c9f058b&"
import script from "./UserSettingsPasswordChange.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports